import { DeliveryProviders } from '~/api/ETA/enums';
import { company } from '~/company/Company';

export const getDeliveryProvider = (): DeliveryProviders => {
  // TODO zh Пока для компании HEIMKAUP используем WOLT вместо OWN_DELIVERY
  if (company.hasWoltDeliveryProvider) {
    return DeliveryProviders.WOLT;
  }

  return DeliveryProviders.OWN_DELIVERY;
};
